<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `master/product/${inputs.id}`
						: `master/product`
				"
			>
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_product_category" class="col-sm-3 mb-0">
						{{ $t("product_category") }}
					</label>
					<app-input
						id="inputs_product_category"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_product_category"
						@input="setProductCategory"
						fetch-url="master/product-category"
						placeholder="Product Category"
						list-value-field="name"
						:required="true"
					/>
				</div> -->

				<div class="form-group row align-items-center" >
					
					<div class="col-sm-12">
						<app-input
							id="inputs_down_payment_status"
							:list-value-field="`Down Payment`"
							type="single-checkbox"
							v-model="inputs.down_payment_status"
						/>
					</div>
				</div>
				<div class="form-group row align-items-center" v-if="showSemester">
					<label for="inputs_academic_calendar_id" class="col-sm-3 mb-0">
						Semester
					</label>
					
					<app-input
						id="inputs_academic_calendar_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_academic_calendar_id"
						@input="setAcademicCalendarId"
						fetch-url="master/academic-calendar"
						placeholder="Semester"
						list-value-field="academic_calendar_name"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_charges_category" class="col-sm-3 mb-0">
						Category
					</label>
					<app-input
						id="inputs_charges_category"
						class="col-sm-9"
						type="search-select"
						:list="chargesCategoryLists"
						v-model="inputs.charges_category"
						@input="handleChargesCategoryChange"
						placeholder="Category"
						required
					/>
				</div>
						
				<div class="form-group row align-items-center" v-if="ShowCenter">
					<label for="inputs_center_id" class="col-sm-3 mb-0">
						Center
					</label>
					<app-input
						id="inputs_center_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_center_id"
						@input="setCenterIdValue"
						fetch-url="master/center"
						placeholder="Center"
						list-value-field="name"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center" v-if="showProductLevel">
					<label for="inputs_product_level_id" class="col-sm-3 mb-0">
						Product Level
					</label>
					<app-input
						id="inputs_product_level_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_product_level_id"
						@input="setProductLevelId"
						fetch-url="master/product-level"
						placeholder="Product Level"
						list-value-field="product_level_desc"
						:required="true"
					/>
				</div>
				
				<div class="form-group row align-items-center" v-if="showPaymentStatus">
					<label for="inputs_payment_status_id" class="col-sm-3 mb-0">
						Payment Status
					</label>
					<app-input
						id="inputs_payment_status_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_payment_status_id"
						@input="setPaymentStatusId"
						:fetch-url="`master/payment-status`"
						placeholder="Payment Status"
						list-value-field="payment_status_desc"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center" v-if="showProductName">
					<label for="inputs_name" class="col-sm-3 mb-0">
						{{ $t("name") }}
					</label>
					<app-input
						id="inputs_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.name"
						:placeholder="$t('name')"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center" v-if="showDescription">
					<label for="inputs_description" class="col-sm-3 mb-0">
						{{ $t("description") }}
					</label>
					<app-input
						id="inputs_description"
						class="col-sm-9"
						type="text"
						v-model="inputs.description"
						:placeholder="$t('description')"
						:required="true"
					/>
				</div>

				<!-- Center ID -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_center_id" class="col-sm-3 mb-0">
						{{ $t("center") }}
					</label>

					<app-input
						id="inputs_center"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_center"
						@input="setCenter"
						:fetch-url="`master/center?is_active=true`"
						:placeholder="this.$t('center')"
						list-value-field="name"
					/>
				</div> -->

				<!-- Price -->
				<div class="form-group row align-items-center">
					<label for="inputs_price" class="col-sm-3 mb-0">
						Price
					</label>
					<app-input
						id="inputs_price"
						class="col-sm-9"
						type="number"
						v-model="inputs.price"
						placeholder="Price"
						:required="true"
					/>
				</div>

				<!-- <div class="form-group row align-items-center">
                    <label for="inputs_product_type" class="col-sm-3 mb-0">
                        {{ $t('product_type') }}
                    </label>
                    <app-input
                        id="inputs_product_type"
                        type="search-select"
                        class="col-sm-9"
                        :list="product_types"
                        :isAnimatedDropdown="true"
                        :placeholder="$t('product_type')"
                        v-model="inputs.product_type"
                        @input="setProductType"
                    />
                </div> -->

				<div class="form-group row align-items-center">
					<label for="inputs_is_active" class="col-sm-3 mb-0">
						&nbsp;
					</label>
					<div class="col-sm-8">
						<app-input
							id="inputs_is_active"
							:list-value-field="$t('is_active')"
							type="single-checkbox"
							v-model="inputs.is_active"
						/>
					</div>
				</div>
				<!-- <div class="form-group row align-items-center">
                    <label for="inputs_email" class="col-sm-3 mb-0">
                        {{ $t('email') }}
                    </label>
                    <app-input id="inputs_email"
                               class="col-sm-9"
                               type="email"
                               v-model="inputs.email"
                               :placeholder="$t('email_type_input')"
                               :required="true"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_phone" class="col-sm-3 mb-0">
                        {{ $t('contact_number') }}
                    </label>
                    <app-input id="inputs_phone"
                               class="col-sm-9"
                               type="tel-input"
                               v-model="phone"
                               :placeholder="$t('type_contact_number')"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_status" class="col-sm-3 mb-0">
                        {{ $t('status') }}
                    </label>
                    <app-input id="inputs_status"
                               class="col-sm-9"
                               type="select"
                               :required="true"
                               v-model="inputs.status"
                               :list="statusLists"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_age" class="col-sm-3 mb-0">
                        {{ $t('age') }}
                    </label>
                    <app-input id="inputs_age"
                               class="col-sm-9"
                               type="number"
                               :max-number="100"
                               v-model="inputs.age"
                               :placeholder="$t('type_age')"/>
                </div>
                <div class="form-group row align-items-center mb-0">
                    <label class="col-sm-3 mb-0">
                        {{ $t('gender') }}
                    </label>
                    <app-input class="col-sm-9"
                               type="radio"
                               v-model="inputs.gender"
                               :list="genderLists"/> -->
				<!-- </div> -->

				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					product_category_id: undefined,
					code: "",
					name: "",
					is_active: "",
					product_category: {
						id: undefined,
						code: "",
						name: "",
						is_active: "",
					},
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			showProductLevel : false,
			showPaymentStatus : false,
			showSemester : false,
			ShowCenter : false,
			showProductName : false,
			showDescription : false,
			input_academic_calendar_id : {},
			input_product_category: this.value
				? this.value.product_category
					? {
							id: this.value.product_category.id || 0,
							name: this.value.product_category.name || "",
							code: this.value.product_category.code,
							is_active: this.value.product_category.is_active,
					  }
					: {
							id: this.value.product_category?.id || 0,
							name: this.value.product_category?.name || "",
							code: this.value.product_category?.code,
							is_active: this.value.product_category?.is_active,
					  }
				: {
						id: this.value.product_category.id || 0,
						name: this.value.product_category.name || "",
						code: this.value.product_category.code,
						is_active: this.value.product_category.is_active,
				  },
				  
				input_product_level_id : {},
				input_payment_status_id : {},
				input_center_id : {},
						
			chargesCategoryLists: [
				{ id: 1, value: "Material Fee" },
				{ id: 2, value: "Registration" },
				{ id: 3, value: "Admision" },
				{ id: 4, value: "Other" },
			],
			product_types: [
				{
					id: 1,
					value: "Course",
				},
				{
					id: 2,
					value: "Charge",
				},
				{
					id: 3,
					value: "Deduction",
				},
			],
			inputs: {
				name: "",
				description: "",
				down_payment_status: false
			},
			// statusLists: [
			//     {id: '', value: "Choose One",},
			//     {id: 'active', value: "Active",},
			//     {id: 'inactive', value: "Inactive",},
			//     {id: 'invited', value: "Invite",},
			// ],
			// genderLists: [
			//     {id: 'male', value: "Male"},
			//     {id: 'female', value: "Female"},
			//     {id: 'other', value: "Other"},
			// ],
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		handleChargesCategoryChange(value) {
			
			if(value == 1){

				this.showSemester = true;
				this.showProductLevel = true;
				this.showPaymentStatus = true;
				this.ShowCenter = true;
				this.showProductName = false;
				this.showDescription = false;

			}else if(value == 2){

				this.showSemester = false;
				this.showProductLevel = false;
				this.showPaymentStatus = false;
				this.ShowCenter = false;
				this.showProductName = false;
				this.showDescription = false;

			}else if(value == 3){

				this.showSemester = false;
				this.showProductLevel = false;
				this.showPaymentStatus = false;
				this.ShowCenter = false;
				this.showProductName = false;
				this.showDescription = false;
						
			}else if(value == 4){

				this.showSemester = true;
				this.showProductLevel = false;
				this.showPaymentStatus = false;
				this.ShowCenter = false;
				this.showProductName = true;
				this.showDescription = true;
						
			}

		},
		submit() {
			this.inputs.product_category_id = 2;
			if (this.selectedUrl) {
				this.inputs.created_at = this.formattedDate(
					this.inputs.created_at
				)
					? this.formattedDate(this.inputs.created_at)
					: this.formattedDate(new Date());
				this.inputs.updated_at = this.formattedDate(new Date());
				this.inputs.created_by = this.inputs.created_by.id;
				this.inputs.updated_by = this.inputs.updated_by.id;
			}
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {

			this.inputs = response.data;

			this.inputs.price = this.inputs.price
				? this.inputs.price.toString().split(".")[0]
				: "";

			this.input_academic_calendar_id = {
				id: response.data.semester?.id,
				academic_calendar_name: response.data.semester?.academic_calendar_name,
				is_active: response.data.semester?.is_active,
			};
			this.inputs.academic_calendar_id =response.data.semester?.id; 
			if(response.data.charges_category == 1){

				this.showProductLevel = true;
				this.showPaymentStatus = true;
				this.ShowCenter = true;
				this.showProductName = false;
				this.showDescription = false;
				
				this.input_product_level_id = {
					product_level_id: response.data.product_level.product_level_id,
					level_id: response.data.product_level.level_id,
					product_level_code: response.data.product_level.product_level_code,
					product_level_desc: response.data.product_level.product_level_desc,
					is_active: response.data.product_level.is_active,
				};

				this.input_payment_status_id = {
					id: response.data.payment_status.id,
					payment_status_id: response.data.payment_status.payment_status_id,
					payment_status_code: response.data.payment_status.payment_status_code,
					payment_status_desc: response.data.payment_status.payment_status_desc,
					is_active: response.data.payment_status.is_active,
				};
				
				this.input_center_id = {
					id: response.data.center?.id,
					name: response.data.center?.name,
					is_active: response.data.center?.is_active,
				};


			}else if(response.data.charges_category == 2){

				this.showProductLevel = false;
				this.showPaymentStatus = false;
				this.ShowCenter = true;
				this.showProductName = false;
				this.showDescription = false;

				this.input_center_id = {
					id: response.data.center?.id,
					name: response.data.center?.name,
					is_active: response.data.center?.is_active,
				};

			}else if(response.data.charges_category == 3){

				this.showProductLevel = false;
				this.showPaymentStatus = false;
				this.ShowCenter = true;
				this.showProductName = false;
				this.showDescription = false;
						
				this.input_center_id = {
					id: response.data.center?.id,
					name: response.data.center?.name,
					is_active: response.data.center?.is_active,
				};

			}else if(response.data.charges_category == 4){

				this.showProductLevel = false;
				this.showPaymentStatus = false;
				this.ShowCenter = false;
				this.showProductName = true;
				this.showDescription = true;
						
			}

			this.preloader = false;
		},
		setProductCategory(data) {
			this.inputs.product_category_id = this.inputs.product_category_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.product_category_id = data.id;
			}
		},
		setProductType(data) {
			this.inputs.product_type = this.inputs.product_type;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.product_type = data.id;
			}
		},
		// setCenter(data) {
		// 	this.inputs.center_id = this.inputs.center_id;
		// 	if (data && data.hasOwnProperty("id")) {
		// 		this.inputs.center_id = data.id;
		// 	}
		// },
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const hour = date.getHours().toString().padStart(2, "0");
			const minute = date.getMinutes().toString().padStart(2, "0");
			const second = date.getSeconds().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`;

			return formattedDate;
		},
		
		setProductLevelId(data) {
			this.inputs.product_level_id = this.inputs.product_level_id;
			if (data && data.hasOwnProperty("product_level_id")) {
				this.inputs.product_level_id = data.product_level_id;
			}
		},
		setPaymentStatusId(data) {
			this.inputs.payment_status_id = this.inputs.payment_status_id;
			if (data && data.hasOwnProperty("payment_status_id")) {
				this.inputs.payment_status_id = data.id;
			}
		},
		
		setCenterIdValue(data){
			this.inputs.center_id = this.inputs.center_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.center_id = data.id;
			}
		},
		
		setAcademicCalendarId(data) {
			this.inputs.academic_calendar_id = data.id;
			this.input_academic_calendar_id = data;
		},
	},
};
</script>
